/**
 * Chrome fires `beforeinstallprompt` once, early — normally long before anyone
 * navigates to /install — and the event is only usable if it was captured then.
 * So the listener is attached when this module is imported (from main.jsx),
 * not when the page that needs it mounts.
 *
 * Safari has no equivalent API at all; the install page falls back to written
 * steps there, which is why `canInstall()` returning false is a normal state
 * and not an error.
 */
let deferred = null;
const listeners = new Set();

function announce() {
    listeners.forEach((notify) => notify());
}

window.addEventListener('beforeinstallprompt', (event) => {
    // Without this Chrome shows its own mini-infobar and the event is spent.
    event.preventDefault();
    deferred = event;
    announce();
});

window.addEventListener('appinstalled', () => {
    deferred = null;
    announce();
});

export function canInstall() {
    return deferred !== null;
}

// Shaped for useSyncExternalStore(subscribeInstallable, canInstall).
export function subscribeInstallable(notify) {
    listeners.add(notify);
    return () => listeners.delete(notify);
}

export async function promptInstall() {
    const event = deferred;
    if (!event) return false;
    // The event is single-use: dropping it here keeps a second click from
    // calling prompt() again, which throws.
    deferred = null;
    announce();
    await event.prompt();
    const { outcome } = await event.userChoice;
    return outcome === 'accepted';
}
